module.exports = __webpack_public_path__ + "static/media/goBackSFX.5cf651d8.mp3";